import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SplineChart = ({data}) => {
	const options = {
		chart: {
			type: "spline",
			scrollablePlotArea: {
				scrollPositionX: 1,
			},
			margin: [50, 10, 80, 35],
			borderWidth: 1,
			borderRadius: 5,
			borderColor: "#CCC",
			style: {
				fontSize: "16px",
			},
		},
		title: {
			text: "",
			align: "left",
		},
		xAxis: {
			type: "datetime",
			labels: {
				overflow: "justify",
			},
		},
		yAxis: {
			title: { text: null },
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			alternateGridColor: null,
			labels: {
				format: "{value}",
			},
			opposite: false,
		},

		tooltip: {
			valueSuffix: "",
		},
		plotOptions: {
			spline: {
				lineWidth: 4,
				states: {
					hover: {
						lineWidth: 5,
					},
				},
				marker: {
					enabled: false,
				},
				// pointInterval: 108000000 * 24 * 30, // one hour
				// pointStart: Date.UTC(2020, 3, 1),
			},

			series: {
				pointStart: data[0].date.getTime(),
				pointIntervalUnit: 'month'
			}
		},
		legend: {
			enabled: true,
			floating: true,
			align: "left",
			verticalAlign: "top",
			layout: "vertical",
			y: 0,
			x: 30,
			itemStyle: {
				fontSize: "16px",
				fontWeight: "600",
			},
		},
		series: [
			{
				name: "Employees",
				data: data.map((item) => item.employees),
				color: "#ea611c",
			},
			{
				name: "Clients",
				data: data.map((item) => item.clients),
				color: "#00FF00",
			},
		],
		navigation: {
			menuItemStyle: {
				fontSize: "10px",
			},
		},
		credits: {
			enabled: false,
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default SplineChart;
